import { jsxs as d, jsx as r } from "react/jsx-runtime";
import { HighlightedBadge as u } from "./HighlightedBadge.js";
import { PromoBadges as _ } from "../../../PromoBadges/PromoBadges.js";
import { a as p } from "../../../checks-C6AyTTQ0.js";
import { c as h } from "../../../clsx-OuTLNxxd.js";
const g = "UnbundlingFareCardHeader-module_header__pURTZ",
  H = "UnbundlingFareCardHeader-module_is-highlighted__0DWbR",
  C = "UnbundlingFareCardHeader-module_header-content__zHRkO",
  b = "UnbundlingFareCardHeader-module_title-wrapper__GBcv2",
  F = "UnbundlingFareCardHeader-module_title__Rt7GF",
  U = "UnbundlingFareCardHeader-module_subtitle__g4qvQ",
  f = "UnbundlingFareCardHeader-module_promos__XF73I",
  e = {
    header: g,
    isHighlighted: H,
    headerContent: C,
    titleWrapper: b,
    title: F,
    subtitle: U,
    promos: f
  },
  y = _ref => {
    let {
      children: i,
      title: s,
      subtitle: t,
      withPromos: o = !1,
      highlighted: n = !1,
      highlightedLabel: a,
      promos: l,
      onPromoBadgeClicked: m,
      status: c = "default"
    } = _ref;
    return /* @__PURE__ */d("header", {
      className: h(e.header, {
        [e.isHighlighted]: n && a
      }),
      children: [n && a && /* @__PURE__ */r(u, {
        status: c,
        children: a
      }), /* @__PURE__ */d("div", {
        className: e.headerContent,
        children: [/* @__PURE__ */d("div", {
          className: e.titleWrapper,
          children: [t && /* @__PURE__ */r("div", {
            className: e.subtitle,
            children: t
          }), /* @__PURE__ */r("div", {
            className: e.title,
            children: s
          }), o && p(l) && /* @__PURE__ */r(_, {
            promos: l,
            className: e.promos,
            inverted: !0,
            onPromoBadgeClicked: m,
            variant: "small"
          })]
        }), i]
      })]
    });
  };
export { y as UnbundlingFareCardHeader };